import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import * as i3 from 'base-fee-calculation-library';
import { BaseFeeCalculationLibraryService } from 'base-fee-calculation-library';
import * as i1 from '@ngrx/store';
import * as i2 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'app-services-library';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/button';
import * as i8 from '@angular/forms';
import * as i9 from 'primeng/table';
import * as i10 from 'primeng/api';
import * as i11 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i12 from 'primeng/inputtext';
import * as i13 from 'primeng/tooltip';
import * as i14 from '@angular/material/icon';
import * as i15 from 'primeng/accordion';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';

class FeeCalculationLibraryService {
    constructor() { }
}
FeeCalculationLibraryService.ɵfac = function FeeCalculationLibraryService_Factory(t) { return new (t || FeeCalculationLibraryService)(); };
FeeCalculationLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: FeeCalculationLibraryService, factory: FeeCalculationLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FeeCalculationLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["feeCalculationForm"];
function FeeCalculationLibraryComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "a", 8);
    i0.ɵɵtext(2, "Check here");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " for USCIS Fee Schedule Link ");
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5, " Check here for USCIS Fee Schedule for Form I-131: ");
    i0.ɵɵelementStart(6, "a", 9);
    i0.ɵɵtext(7, "USCIS Fee Schedule");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FeeCalculationLibraryComponent_div_9_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 17);
    i0.ɵɵtext(2, "Fee type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 17);
    i0.ɵɵtext(4, "Fee Calculation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 18);
    i0.ɵɵtext(6, "Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 19);
    i0.ɵɵtext(8, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵelementStart(1, "i", 29);
    i0.ɵɵtext(2, "info_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matTooltip", ctx_r10.formatTooltip(item_r7.rule));
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Set by user");
    i0.ɵɵelementEnd();
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "System Generated ");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r7.ruleApplied);
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Fixed");
    i0.ɵɵelementEnd();
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.getGlobalErrorMessages("REQUIRED"), " ");
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r24.getGlobalErrorMessages("INVALID_NUMBER"), " ");
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_div_2_span_1_Template, 2, 1, "span", 32);
    i0.ɵɵtemplate(2, FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_div_2_span_2_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(4);
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r1.controls["applicableFee"].errors == null ? null : _r1.controls["applicableFee"].errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r1.controls["applicableFee"].invalid);
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 30, 31);
    i0.ɵɵlistener("ngModelChange", function FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r27); const item_r7 = i0.ɵɵnextContext().$implicit; return item_r7.applicableFee = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_div_2_Template, 3, 2, "div", 3);
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngModel", item_r7.applicableFee)("disabled", ctx_r14.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r1.controls["applicableFee"].touched && _r1.controls["applicableFee"].invalid);
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "currency");
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 1, item_r7.applicableFee, "USD"), " ");
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34);
    i0.ɵɵlistener("click", function FeeCalculationLibraryComponent_div_9_ng_template_5_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r32); const item_r7 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(2); ctx_r30.onRowEditInit(item_r7); return ctx_r30.updateControls(true); });
    i0.ɵɵelementStart(1, "mat-icon", 35);
    i0.ɵɵtext(2, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r16.disabledControls || ctx_r16.enableEdit);
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function FeeCalculationLibraryComponent_div_9_ng_template_5_button_14_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r35); const item_r7 = i0.ɵɵnextContext().$implicit; const ctx_r33 = i0.ɵɵnextContext(2); ctx_r33.onRowEditSave(item_r7); return ctx_r33.updateControls(false); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵproperty("disabled", ctx_r17.disabledControls || _r1.invalid);
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function FeeCalculationLibraryComponent_div_9_ng_template_5_button_15_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(); const item_r7 = ctx_r37.$implicit; const ri_r9 = ctx_r37.rowIndex; const ctx_r36 = i0.ɵɵnextContext(2); ctx_r36.onRowEditCancel(item_r7, ri_r9); return ctx_r36.updateControls(false); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r18.disabledControls);
} }
function FeeCalculationLibraryComponent_div_9_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 20);
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FeeCalculationLibraryComponent_div_9_ng_template_5_span_3_Template, 3, 1, "span", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 17);
    i0.ɵɵtemplate(5, FeeCalculationLibraryComponent_div_9_ng_template_5_span_5_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(6, FeeCalculationLibraryComponent_div_9_ng_template_5_span_6_Template, 5, 1, "span", 3);
    i0.ɵɵtemplate(7, FeeCalculationLibraryComponent_div_9_ng_template_5_span_7_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 18);
    i0.ɵɵelementStart(9, "p-cellEditor");
    i0.ɵɵtemplate(10, FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_10_Template, 3, 3, "ng-template", 22);
    i0.ɵɵtemplate(11, FeeCalculationLibraryComponent_div_9_ng_template_5_ng_template_11_Template, 2, 4, "ng-template", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 24);
    i0.ɵɵtemplate(13, FeeCalculationLibraryComponent_div_9_ng_template_5_button_13_Template, 3, 1, "button", 25);
    i0.ɵɵtemplate(14, FeeCalculationLibraryComponent_div_9_ng_template_5_button_14_Template, 1, 1, "button", 26);
    i0.ɵɵtemplate(15, FeeCalculationLibraryComponent_div_9_ng_template_5_button_15_Template, 1, 1, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const editing_r8 = ctx.editing;
    i0.ɵɵproperty("pEditableRow", item_r7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r7.feeTypeName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r7.rule);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r7.isCustomized === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r7.isCustomized && item_r7.rule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r7.isCustomized && !item_r7.rule);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", !editing_r8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", editing_r8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", editing_r8);
} }
function FeeCalculationLibraryComponent_div_9_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 38);
    i0.ɵɵtext(2, "Total");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 18);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "th");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("$", ctx_r6.feeTotal, ".00");
} }
function FeeCalculationLibraryComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵelementStart(3, "p-table", 12);
    i0.ɵɵtemplate(4, FeeCalculationLibraryComponent_div_9_ng_template_4_Template, 9, 0, "ng-template", 13);
    i0.ɵɵtemplate(5, FeeCalculationLibraryComponent_div_9_ng_template_5_Template, 16, 9, "ng-template", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵelementStart(7, "div", 11);
    i0.ɵɵelementStart(8, "p-table");
    i0.ɵɵtemplate(9, FeeCalculationLibraryComponent_div_9_ng_template_9_Template, 6, 1, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 15);
    i0.ɵɵelement(11, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r2.feeCalculation);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngClass", _r1.invalid || ctx_r2.disabledControls ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn btn-primary" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn btn-primary")("disabled", _r1.invalid || ctx_r2.disabledControls || !(ctx_r2.feeCalculation == null ? null : ctx_r2.feeCalculation.length));
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 17);
    i0.ɵɵtext(2, "Fee type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 17);
    i0.ɵɵtext(4, "Fee Calculation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 18);
    i0.ɵɵtext(6, "Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 19);
    i0.ɵɵtext(8, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵelementStart(1, "i", 29);
    i0.ɵɵtext(2, "info_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r44 = i0.ɵɵnextContext().$implicit;
    const ctx_r47 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("matTooltip", ctx_r47.formatTooltip(item_r44.rule));
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Set by user");
    i0.ɵɵelementEnd();
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "System Generated ");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r44 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r44.ruleApplied);
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Fixed");
    i0.ɵɵelementEnd();
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r60.getGlobalErrorMessages("REQUIRED"), " ");
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r61.getGlobalErrorMessages("INVALID_NUMBER"), " ");
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_div_2_span_1_Template, 2, 1, "span", 32);
    i0.ɵɵtemplate(2, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_div_2_span_2_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(5);
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r1.controls["applicableFee"].errors == null ? null : _r1.controls["applicableFee"].errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r1.controls["applicableFee"].invalid);
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 30, 31);
    i0.ɵɵlistener("ngModelChange", function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r64); const item_r44 = i0.ɵɵnextContext().$implicit; return item_r44.applicableFee = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_div_2_Template, 3, 2, "div", 3);
} if (rf & 2) {
    const item_r44 = i0.ɵɵnextContext().$implicit;
    const ctx_r51 = i0.ɵɵnextContext(3);
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngModel", item_r44.applicableFee)("disabled", ctx_r51.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r1.controls["applicableFee"].touched && _r1.controls["applicableFee"].invalid);
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "currency");
} if (rf & 2) {
    const item_r44 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 1, item_r44.applicableFee, "USD"), " ");
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34);
    i0.ɵɵlistener("click", function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r69); const item_r44 = i0.ɵɵnextContext().$implicit; const ctx_r67 = i0.ɵɵnextContext(3); ctx_r67.onRowEditInit(item_r44); return ctx_r67.updateControls(true); });
    i0.ɵɵelementStart(1, "mat-icon", 35);
    i0.ɵɵtext(2, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r53.disabledControls || ctx_r53.enableEdit);
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_14_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r72); const item_r44 = i0.ɵɵnextContext().$implicit; const ctx_r70 = i0.ɵɵnextContext(3); ctx_r70.onRowEditSave(item_r44); return ctx_r70.updateControls(false); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(4);
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵproperty("disabled", ctx_r54.disabledControls || _r1.invalid);
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_15_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r75); const ctx_r74 = i0.ɵɵnextContext(); const item_r44 = ctx_r74.$implicit; const ri_r46 = ctx_r74.rowIndex; const ctx_r73 = i0.ɵɵnextContext(3); ctx_r73.onRowEditCancel(item_r44, ri_r46); return ctx_r73.updateControls(false); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r55.disabledControls);
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 20);
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_span_3_Template, 3, 1, "span", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 17);
    i0.ɵɵtemplate(5, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_span_5_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(6, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_span_6_Template, 5, 1, "span", 3);
    i0.ɵɵtemplate(7, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_span_7_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 18);
    i0.ɵɵelementStart(9, "p-cellEditor");
    i0.ɵɵtemplate(10, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_10_Template, 3, 3, "ng-template", 22);
    i0.ɵɵtemplate(11, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_ng_template_11_Template, 2, 4, "ng-template", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 24);
    i0.ɵɵtemplate(13, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_13_Template, 3, 1, "button", 25);
    i0.ɵɵtemplate(14, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_14_Template, 1, 1, "button", 26);
    i0.ɵɵtemplate(15, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_button_15_Template, 1, 1, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r44 = ctx.$implicit;
    const editing_r45 = ctx.editing;
    i0.ɵɵproperty("pEditableRow", item_r44);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r44.feeTypeName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r44.rule);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r44.isCustomized === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r44.isCustomized && item_r44.rule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r44.isCustomized && !item_r44.rule);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", !editing_r45);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", editing_r45);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", editing_r45);
} }
function FeeCalculationLibraryComponent_div_10_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-accordionTab", 41);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵelementStart(3, "p-table", 12);
    i0.ɵɵtemplate(4, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_4_Template, 9, 0, "ng-template", 13);
    i0.ɵɵtemplate(5, FeeCalculationLibraryComponent_div_10_ng_template_2_ng_template_5_Template, 16, 9, "ng-template", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const secItem_r41 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("header", secItem_r41.feeSectionName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", secItem_r41.fees);
} }
function FeeCalculationLibraryComponent_div_10_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 38);
    i0.ɵɵtext(2, "Total");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 18);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "th");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("$", ctx_r40.feeTotal, ".00");
} }
function FeeCalculationLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-accordion", 39);
    i0.ɵɵlistener("onOpen", function FeeCalculationLibraryComponent_div_10_Template_p_accordion_onOpen_1_listener($event) { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(); return ctx_r76.onTabOpen($event); });
    i0.ɵɵtemplate(2, FeeCalculationLibraryComponent_div_10_ng_template_2_Template, 6, 2, "ng-template", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵelementStart(5, "p-table");
    i0.ɵɵtemplate(6, FeeCalculationLibraryComponent_div_10_ng_template_6_Template, 6, 1, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵelement(8, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.feeCalculation);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", _r1.invalid || ctx_r3.disabledControls ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn btn-primary" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn btn-primary")("disabled", _r1.invalid || ctx_r3.disabledControls || !(ctx_r3.feeCalculation == null ? null : ctx_r3.feeCalculation.length));
} }
class FeeCalculationLibraryComponent extends BaseFeeCalculationLibraryService {
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, appServicesLibraryService) {
        super(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, appServicesLibraryService);
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
        this.isWizard = false;
    }
    ngAfterViewInit() {
        super.loadAfterViewInit();
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        super.loadInit();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    formatTooltip(item) {
        return item.replace(/,/g, '\n');
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
FeeCalculationLibraryComponent.ɵfac = function FeeCalculationLibraryComponent_Factory(t) { return new (t || FeeCalculationLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.APIFeeCalculation), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService)); };
FeeCalculationLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FeeCalculationLibraryComponent, selectors: [["fee-calculation-library"]], viewQuery: function FeeCalculationLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.feeCalculationForm = _t.first);
    } }, inputs: { primaryData: "primaryData", isWizard: "isWizard" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 4, consts: [[1, "row", "col-md-12", "d-flex", "align-items-center", "pb-2"], [1, "col-6"], [1, "heading", "pl-0", "pb-0"], [4, "ngIf"], [1, "col-md-6", "pull-right"], ["type", "button", "pButton", "", "label", "Reset", 1, "p-button-outlined", "pull-right", "btn", 3, "disabled", "click"], ["id", "feeCalculation", 3, "ngSubmit"], ["feeCalculationForm", "ngForm"], ["href", "https://www.uscis.gov/sites/default/files/document/forms/g-1055.pdf", "target", "_blank", "rel", "noopener noreferrer"], ["href", "https://www.uscis.gov/g-1055?form=i-131", "target", "_blank", "rel", "noopener noreferrer"], [1, "row"], [1, "col", "pr-0"], ["dataKey", "feeTypeCode", "editMode", "row", 1, "uscis-table", "table-striped-simple", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "row", "col-md-12", "pt-3"], ["pButton", "", "type", "submit", "label", "Save", 3, "ngClass", "disabled"], ["colspan", "3"], ["colspan", "2"], [1, "text-center"], [3, "pEditableRow"], ["class", "mat-icon", "matTooltipPosition", "right", "matTooltipClass", "custom-tooltip", 3, "matTooltip", 4, "ngIf"], ["pTemplate", "input"], ["pTemplate", "output"], [1, "text-center", "pl-0", "pr-0"], ["pButton", "", "pRipple", "", "type", "button", "pInitEditableRow", "", "pTooltip", "Edit", "class", "p-button-rounded p-button-text", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "pSaveEditableRow", "", "icon", "pi pi-check", "class", "p-button-rounded p-button-text p-button-success p-mr-2", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "pCancelEditableRow", "", "icon", "pi pi-times", "class", "p-button-rounded p-button-text p-button-danger", 3, "disabled", "click", 4, "ngIf"], ["matTooltipPosition", "right", "matTooltipClass", "custom-tooltip", 1, "mat-icon", 3, "matTooltip"], [1, "material-icons", "align-bottom"], ["pInputText", "", "type", "text", "name", "applicableFee", "maxlength", "5", "pattern", "^[0-9]*$", "min", "0", "required", "", 3, "ngModel", "disabled", "ngModelChange"], ["applicableFee", "ngModel"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], ["pButton", "", "pRipple", "", "type", "button", "pInitEditableRow", "", "pTooltip", "Edit", 1, "p-button-rounded", "p-button-text", 3, "disabled", "click"], [1, "mr-1", "icn"], ["pButton", "", "pRipple", "", "type", "button", "pSaveEditableRow", "", "icon", "pi pi-check", 1, "p-button-rounded", "p-button-text", "p-button-success", "p-mr-2", 3, "disabled", "click"], ["pButton", "", "pRipple", "", "type", "button", "pCancelEditableRow", "", "icon", "pi pi-times", 1, "p-button-rounded", "p-button-text", "p-button-danger", 3, "disabled", "click"], ["colspan", "6"], [1, "multiFeeAccordion", 3, "onOpen"], ["ngFor", "", 3, "ngForOf"], [3, "header"]], template: function FeeCalculationLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h6", 2);
        i0.ɵɵtext(3, "View Fees");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, FeeCalculationLibraryComponent_span_4_Template, 8, 0, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "button", 5);
        i0.ɵɵlistener("click", function FeeCalculationLibraryComponent_Template_button_click_6_listener() { return ctx.resetFeeCalucation(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "form", 6, 7);
        i0.ɵɵlistener("ngSubmit", function FeeCalculationLibraryComponent_Template_form_ngSubmit_7_listener() { return ctx.postFeeCalculation(); });
        i0.ɵɵtemplate(9, FeeCalculationLibraryComponent_div_9_Template, 12, 3, "div", 3);
        i0.ɵɵtemplate(10, FeeCalculationLibraryComponent_div_10_Template, 9, 3, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.immigrationCategory) !== "EOIR");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.showMultipleApplicantsFeeStructure);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showMultipleApplicantsFeeStructure);
    } }, directives: [i6.NgIf, i7.ButtonDirective, i8.ɵangular_packages_forms_forms_ba, i8.NgControlStatusGroup, i8.NgForm, i9.Table, i10.PrimeTemplate, i6.NgClass, i9.EditableRow, i9.CellEditor, i11.MatTooltip, i8.DefaultValueAccessor, i12.InputText, i8.MaxLengthValidator, i8.PatternValidator, i8.RequiredValidator, i8.NgControlStatus, i8.NgModel, i9.InitEditableRow, i13.Tooltip, i14.MatIcon, i9.SaveEditableRow, i9.CancelEditableRow, i15.Accordion, i6.NgForOf, i15.AccordionTab], pipes: [i6.CurrencyPipe], styles: [".uscis-table[_ngcontent-%COMP%]{color:#888;border-top:none!important;font-size:13px}.uscis-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;padding:15px!important;color:#4a4a4a;font-style:normal;font-variant:normal;font-weight:700;font-size:13px}.uscis-table[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0 0 10px!important;color:#4a4a4a}.uscis-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child{border-bottom:1px solid #e9ecef}.save-btn[_ngcontent-%COMP%]{border-top:1px solid #e9ecef}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.custom-tooltip[_ngcontent-%COMP%]{white-space:pre-line}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FeeCalculationLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'fee-calculation-library',
                templateUrl: 'fee-calculation-library.component.html',
                styleUrls: ['fee-calculation-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.ToastrService }, { type: i3.APIFeeCalculation }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.AppServicesLibraryService }]; }, { feeCalculationForm: [{
            type: ViewChild,
            args: ['feeCalculationForm', { static: true }]
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], isWizard: [{
            type: Input
        }] }); })();

class FeeCalculationLibraryModule {
}
FeeCalculationLibraryModule.ɵfac = function FeeCalculationLibraryModule_Factory(t) { return new (t || FeeCalculationLibraryModule)(); };
FeeCalculationLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: FeeCalculationLibraryModule });
FeeCalculationLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseFeeCalculationLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            MatTooltipModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FeeCalculationLibraryModule, { declarations: [FeeCalculationLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        MatTooltipModule], exports: [FeeCalculationLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FeeCalculationLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [FeeCalculationLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    MatTooltipModule,
                ],
                providers: [BaseFeeCalculationLibraryService],
                exports: [FeeCalculationLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fee-calculation-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FeeCalculationLibraryComponent, FeeCalculationLibraryModule, FeeCalculationLibraryService };
//# sourceMappingURL=fee-calculation-library.js.map
